<template>
    <div :class="['content-container', 'ipad', {'desktop': !this.isIpad}]">

        <NavBar :title="setTitle" custom-class="timeline-back-button" ></NavBar>

       
        <!-- Content -->
        <div class="container pt-0 px-0" v-if="itemsToShow">


            <div class="d-flex align-items-center filter-container">
                <Filters @change="filterTitleChange($event)" @updateModal="setMoaModalByEvent" @itemsChange="setGrids"></Filters>
                <div v-if="moaModal" class="moaButton">
                    <button type="button" class="btn btn-outline-primary" data-toggle="modal" data-target="#moa-modal" @click="trackMoaModal()">
                        <span class="d-flex align-items-center justify-content-center button-span">
                            <span class="mr-1 ml-auto">MoA</span>
                            <svg class="ml-auto" height="16px" aria-hidden="true" focusable="false" data-prefix="fas"
                                 data-icon="angle-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                                <path fill="#00bcff"
                                    d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
                                class=""></path>
                            </svg>
                        </span>
                    </button>
                </div>
            </div>
            <Moa-modal :product="moaModal" class="moa-button"></Moa-modal>
            <div class="timeline">
                    <div class="timeline-group"
                         :class="currentYear === yearData.year ? 'group-is-current-year' :'' "
                         v-for="yearData in timelineItemsComputed"
                         :key="yearData.year"
                         :id="'timeline-group-' + yearData.year +''"
                    >
                        <h2 class="text-center timeline-title">{{ yearData.year}}</h2>

                        <div class="timeline-year" :class="'timeline-year-' + yearData.year + ''" >
                            <ul class="month-list" :class="currentYear === yearData.year ? 'is-current-year' :'' ">
                                <li v-for="(monthData, monthIndex) in yearData.data"
                                    class="month-list__month"
                                    :class="currentYear === yearData.year ? 'month-display': '' "
                                    :data-month="currentYear === yearData.year ? months[(monthData.month - 1)] : '' "
                                    :key="monthIndex"
                                >

                                    <div class="month-list__container" :class="'grid-month-' + monthData.month +''">

                                        <div class="month-list__grid"  :class="setClassName(monthData.month)">
                                            <template v-for="(dayData, dayIndex) in monthData.data">

                                                <div :class="'grid-day-' + dayData.day + ''" class="grid-day" :key="dayIndex">
                                                    <ul class="items-list">
                                                        <li v-for="item in dayData.data"
                                                            :data-reverseContent="item.positionIndex"
                                                            :data-phase="getPhaseData(item.field_phase_tag[0].target_id, 'name', 'value')"
                                                            :data-product="getTaxonomyData(item.field_product_list[0].target_id, 'title', 'value')"
                                                            class="timeline-item"
                                                            :data-node-id="item.nid[0].value"
                                                            :class="getDiseaseStateClassName( (item.field_disease_state_tag.length ? item.field_disease_state_tag[0].target_id : '')) | toClassName"
                                                            :data-diseasestate="getDiseaseState( (item.field_disease_state_tag.length ? item.field_disease_state_tag : ''), 'name', 'value')"
                                                            :key="item.nid[0].value"
                                                        >
                                                            <div class="timeline-content">
                                                                <router-link :to="getlink(item.nid[0].value)"
                                                                             @click.native="trackEvent"
                                                                             data-category="Timeline Navigation"
                                                                             data-action="button_press"
                                                                             :data-event="getTrackingLabelData(item)"
                                                                >
                                                                    <img :src="setImagePath(item.field_trial_logo[0].url)" class="timeline-logo">
                                                                    <p class="phase">{{ getPhaseData(item.field_phase_tag[0].target_id, 'name', 'value') }}</p>
                                                                    <h2>
                                                                        {{ getTaxonomyData(item.field_product_list[0].target_id, 'title', 'value') }}
                                                                    </h2>
                                                                </router-link>
                                                            </div>
                                                            <span class="count">
                                                                <img src="img/ui-elements/timeline-user.png" class="user-icon" />
                                                                {{item.field_number_of_participants[0].value }}
                                                            </span>
                                                        </li>
                                                    </ul>

                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
            </div>

            <Approval v-if="this.isIpad" timeline="timeline-approval"></Approval>

            <!-- Legend -->
            <ul class="timeline-legend">
                <li class="venous-protection" v-if="legendItems.indexOf('venous-protection') > -1">Venous protection</li>
                <li class="vascular-protection" v-if="legendItems.indexOf('vascular-protection') > -1">Vascular protection</li>
                <li class="stroke-prevention" v-if="legendItems.indexOf('stroke-prevention') > -1">Stroke prevention</li>
                <li class="cardiorenal" v-if="legendItems.indexOf('cardiorenal') > -1">CardioRenal</li>
            </ul>
        </div>
        <div v-else class="container">
            <div class="alert alert-danger" role="alert">
                There are no available products. 
             </div>
        </div>

        <!-- Background Image -->
        <div class="img-bg">
            <img src="img/backgrounds/timeline.png" class="bottom-center">
        </div>

        <Disclaimer timeline="true"></Disclaimer>
        <ReusableDisclaimer :params="disclaimerParams" @accepted="onAccepted"></ReusableDisclaimer>
    </div>
</template> 

<script>

    import NavBar from './components/NavBar'; 
    import Filters from './components/Filters'; 
    import getTaxonomyData from './components/getTaxonomyData'; 
    import Disclaimer from './components/DisclaimerModal.vue'; 
    import Approval from './components/Approval.vue';
    import MoaModal from './components/MoaModal.vue';
    import ReusableDisclaimer from './components/ReusableDisclaimerModal.vue';

    export default {
        extends: getTaxonomyData,
        name: 'Timeline',
        data: function() {
            return {
                legendItems: [],
                pageTitle: false,
                itemsToShow: true,
                vm: this,
                styleProp: '',
                moaModalProduct: false,
                shortMonth: [
                    2,
                ],
                middleMonth: [
                    9, 4, 6, 11
                ],
                months: [
                    'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep',
                    'oct', 'nov', 'dec'
                ],
                checkCache: false,
                intersectionOb: '',
                todayInView: false,
                disclaimerParams: null,
            }
        },
        components: {
            NavBar,
            Filters,
            Disclaimer,
            Approval,
            MoaModal,
            ReusableDisclaimer,
        },
        filters: {
            toClassName: function(str) {
                let s = str.replace(' ', '-');
                return s.toLowerCase();
            },
        },
        created: async function() {
            this.setMoaModal();
        },
        mounted: async function(){
            window.grid = this;
            let logos = this.$store.getters.getTrialImages;
            try {
                if (logos.length > 0) {
                    await this.$imagePreload(logos);
                }
            } catch (e) {
                // pass
            }
            this.setToday();

            if (!this.isIpad) {
                this.generateDisclaimerContent();
            }
        },
        watch: {
            '$route' (to) {
                if(to.path == '/timeline') {
                    window.location.reload();
                }
            },
        },
        computed: {
            moaModal() {
                return this.moaModalProduct;
            },
            approval() {return this.$store.getters.getApproval},
            products() {
                return this.$store.getters.allProducts;
            },
            timelineItems() { return this.filterItemsByDate() },
            setTitle(){ return this.pageTitle ? this.pageTitle : ( (this.$route.params.filtertype == undefined) || (this.$route.params.filtertype == 'diseasestate' || this.$route.params.filtertype == 'all') ? (window.localStorage.getItem('appHomepageStatus') !== null ? 'Data Navigator' : '') : this.$route.params.filtervalue) },
            timelineItemsComputed(){ 
                let count = 0;
                
                for(var i=0; i < this.timelineItems.length; i++)
                {
                    for(var j = 0; j < this.timelineItems[i].data.length; j++){
                        for(var k = 0; k < this.timelineItems[i].data[j].data.length; k++){
                            for(var l = 0; l < this.timelineItems[i].data[j].data[k].data.length; l++) {
                                // eslint-disable-next-line
                                this.timelineItems[i].data[j].data[k].data[l].positionIndex = (count % 2) !== 0 ? 'reverseContent' : ''; 
                                count++;
                            }
                        }
                    }
                }
                return this.timelineItems; 
            },
            currentYear: function(){
                let d = new Date();
                return d.getFullYear();
            },

        },
        methods: {
            generateDisclaimerContent: function() {
                const source = this.$route.params.filtervalue || 'see_all';
                this.disclaimerParams = this.getDisclaimerContent(source);
            },
            getDisclaimerContent: function(source) {
                const title = this.$route.params.filtertype || 'see_all';
                const sourceMap = {
                    'product': () => this.getProductDisclaimer(source),
                    'diseasestate': () => this.getDiseaseStateDisclaimer(source),
                    'see_all': () => this.getSeeAllDisclaimer(source),
                };
                return sourceMap[title] ? sourceMap[title]() : this.disclaimers[title.toLowerCase()];
            },
            getProductDisclaimer: function(productName) {
                const productNames = this.$store.getters.getProductNames;
                const product = productNames.filter(item => item.title[0].value === productName);
                let data = null;
                if (product && product[0].field_product_disclaimer.length > 0) {
                    data = {
                        id: productName.toLowerCase(),
                        title: 'Disclaimer',
                        body: product[0].field_product_disclaimer[0].value,
                        button: 'Continue',
                    };
                }
                return data;
            },
            getDiseaseStateDisclaimer: function(stateName) {
                const event = this.$store.getters.getEvent;
                let data = null;
                if (event && 
                    event.field_disease_state_disclaimer.length > 0 &&
                    event.field_event_is_live_[0].value === 'Yes'
                ) {
                    data = {
                        id: stateName.toLowerCase(),
                        title: 'Disclaimer',
                        body: event.field_disease_state_disclaimer[0].value,
                        button: 'Continue',
                    };
                }
                return data;
            },
            getSeeAllDisclaimer: function() {
                const event = this.$store.getters.getEvent;
                let data = null;
                if (event && 
                    event.field_timeline_disclaimer.length > 0 &&
                    event.field_event_is_live_[0].value === 'Yes'
                ) {
                    data = {
                        id: 'see_all',
                        title: 'Disclaimer',
                        body: event.field_timeline_disclaimer[0].value,
                        button: 'Continue',
                    };
                }
                return data;
            },
            trackMoaModal: function() {
                if (this.moaModalProduct) {
                    this.$root.track('callback://screenname_MOA - ' + this.moaModalProduct);
                }
                this.analytics.trackGoal(
                    this.$router.currentRoute.path,
                    'MoA Modal',
                    'moa_modal'
                );
            },
            setGrids: function(action) {
                if(action) {
                    document.querySelector('.month-list.is-current-year').classList.remove('small-grid');
                    return false;
                }
                let legendItems = [];
                let currentYear = document.querySelector('.month-list.is-current-year');
                currentYear.classList.remove('small-grid');
                let itemsList = currentYear.querySelectorAll('.items-list li');
                let allItemsList = document.querySelectorAll('.items-list li');

                [].slice.call(allItemsList).forEach(function (item) {
                    if (!item.hidden) {
                        legendItems = legendItems.concat([].slice.call(item.classList));
                    }
                });



              if (itemsList.length < 1) {
                    //no trials at all. set smaller grid class
                    currentYear.classList.add('small-grid');
                } else {
                    let allHidden = true;
                    itemsList = [].slice.call(itemsList);
                    itemsList.forEach(function (item) {
                        if (!item.hidden) {
                            allHidden = false;
                        }
                    })

                    if (allHidden) {
                        //set class
                        currentYear.classList.add('small-grid');
                    }
                }
                this.legendItems = legendItems;
            },
            setClassName: function(month) {
                if(month === 2) {
                    return 'days-28';
                } else if( this.middleMonth.indexOf(month) > -1) {
                    return 'days-30';
                } else {
                    return '';
                }
            },
            setToday: function() {
                this.setGrids();

                let marker = document.getElementById('today-marker');
                if( marker === null) {
                    let d = new Date();
                    let target = d.getDate();
                    let yr = d.getFullYear();
                    let month = (d.getMonth() + 1);
                    let days = new Date(yr, month, 0).getDate();
                    let monthPercent = d.getDate() / days * 100; // Calculate position within month

                    let selector = this.months[d.getMonth()];

                    let div = document.createElement('div');
                    div.setAttribute('id', 'today-marker');
                    div.classList.add('is-today-marker');
                    div.style.left = monthPercent + '%';

                    let dataSelector = '[data-month="' + selector + '"]';
                    let sel = document.querySelector(dataSelector);

                    sel.appendChild(div);

                } else {
                    // console.log('marker is not null');
                }


                // this.setObserver(document.getElementById('today-marker'));

                this.centerToday();
            },
            setObserver: function(element) {
                const vm = this;
                this.intersectionOb = new IntersectionObserver(function(entries){
                    if(entries[0].intersectionRatio > 0){
                        vm.todayInView = true;
                        //vm.intersectionOb.unobserve(element);
                    } else {
                        vm.todayInView = false;
                    }
                    // console.log(entries[0]);
                    // console.log(vm.todayInView);
                })

                this.intersectionOb.observe(element);
            },
            setMoaModal: function() {
                if (this.$route.params.filtertype === 'product') {
                    this.moaModalProduct = this.$route.params.filtervalue;
                } else {
                    // Default to first available product so MoA button shows on all routes
                    let products = this.$store.getters.getProductNames;
                    this.moaModalProduct = (products && products.length > 0) ? products[0].title[0].value : false;
                }
            },
            setMoaModalByEvent: function(value) {
                //if(this.$route.params.filtertype !== 'product') {
                    this.moaModalProduct = value;
                //} else {
                //}
            },
            canDisplayProduct: function(productId) {

                var notAllowedItems = window.localStorage.getItem('storageProducts'); 

                if(notAllowedItems !== null){
                    var notAllowed = JSON.parse(notAllowedItems); 
                    
                    if(notAllowed.length > 0)
                    {
                        let idIsString = productId.toString(); 
                        if(notAllowed.indexOf(idIsString) > -1)
                        {
                            //console.log('inarray');
                            return false; 
                        }
                    } else {
                        return true; 
                    }
                } 

                return true;
            },
            filterTitleChange: function(str) {
                this.pageTitle = str;
            },
            getlink: function(targetId){
                return '/trials-two/'+targetId;
            },
            placeTodayMarker: function() {
                /* get month and year details */
                let today = new Date(); 
                var year = today.getFullYear(); 
                var month = today.getMonth(); 
                /* work out month as percentage of the year */
                var percent = (month / 11) * 100; 
                
                /* select the relevant element */
                var targetEl = document.querySelector('[data-yeargroup="'+ year +'"]');
                
                /* create the 'today' item, add position left value and append to the 
                    relevant part of the page 
                */
                var listItem = document.createElement('li'); 
                listItem.classList.add('today'); 
                listItem.setAttribute('id', 'today-marker'); 
                listItem.textContent = 'Today'; 
                listItem.style.left = percent+'%'; 
                if(targetEl !== null){
                    targetEl.appendChild(listItem); 
                }

                this.centerToday();
                
                return true;
            }, 
            centerToday: function(){
                const vm = this;
                // setTimeout(function() {

                    let marker = window.$('#today-marker');

                    vm.$nextTick( function() {
                        let containerWidth = window.$(window).width();
                        let halfMarkerWidth = window.$(marker).width() / 2;
                        let halfwidth = containerWidth / 2;
                        let targetWidth = window.$(marker).offset().left + halfwidth - halfMarkerWidth;
                        if(window.$('.timeline').animate)
                        {
                            window.$('.timeline').animate({scrollLeft: targetWidth}, 500);
                        }
                        });

            },
            sortResults: function(results) {

                results = results.sort(function(a,b) {
                        if( a.year < b.year){
                            return -1; 
                        } else {
                            return 1; 
                        }
                });

                for(var i = 0; i < results.length; i++) {

                    results[i].data = results[i].data.sort( function(a,b) {
                        if( a.month < b.month){
                            return -1; 
                        } else {
                            return 1; 
                        }
                    }); 

                    for(var j = 0; j < results[i].data.length; j++ ) {
                        results[i].data[j].data = results[i].data[j].data.sort(function(a,b) {
                            if( a.day < b.day){
                                return -1; 
                            } else {
                                return 1; 
                            }
                        }); 
                       
                    }
                }

                return results;

            },
            createMonthsObject: function() {

                let arr = [];

                for(let month = 1; month < 13; month++) {
                    let o = {
                        month: month,
                        data: [],
                    }
                    arr.push(o);
                }

                return arr;
            },
            createCurrentYear: function() {
                let d = new Date();
                let o = {
                    year: d.getFullYear(),
                    data: this.createMonthsObject()
                }
                return o;

            },
            filterItemsByDate: function() {
                /**
                * group all products in to new array with date keys so we can display in date order
                */

                //let items = this.$store.getters.allProducts;
                let items = this.products;
                var results = [];  
                var vm = this; 
                // let itemIndex = 0;

                items.forEach(function(item) {
                    //console.log(Object.keys(item).length);
                    
                    if(item.type[0].target_id == 'page'){
                                      
                        if (vm.canDisplayProduct(item.field_product_list[0].target_id) ) {
                            let dateMarker = item.field_trial_completion_date[0].value; 

                            let splitDate = dateMarker.split('-'); 

                            let year = parseInt(splitDate[0]); //year 
                            let month = parseInt(splitDate[1]); 
                            let day = parseInt(splitDate[2]); 

                            var thisYear = null; 
                            for( let i=0; i < results.length; i++){

                                if(results[i].year == year) {
                                    thisYear = results[i]; 
                                }

                                
                            }

                            if(thisYear === null) {
                                let d = new Date();
                                if (year == d.getFullYear()) {
                                    thisYear = {
                                        year: year,
                                        data: vm.createMonthsObject()
                                    };
                                } else {
                                    thisYear = {
                                       year: year,
                                        data: []
                                    }
                                }

                                results.push(thisYear);
                            }

                            var thisMonth = null; 
                            for(var m = 0; m< thisYear.data.length; m++) {
                                if(thisYear.data[m].month == month) {
                                    thisMonth = thisYear.data[m]; 
                                }
                            }

                            if(thisMonth === null) {
                                    thisMonth = {
                                        month: month,
                                        data: [] 
                                    }

                                    thisYear.data.push(thisMonth); 
                                }

                            var thisDay = null; 
                            for(var n = 0; n< thisMonth.data.length; n++) {
                                
                                if(thisMonth.data[n].day == day)
                                {
                                    thisDay = thisMonth.data[n]; 
                                }

                                
                            }

                            if (thisDay === null) {
                                thisDay = {
                                    day: day,
                                    data: []
                                }

                                thisMonth.data.push(thisDay);
                            }

                            thisDay.data.push(item); 
                        }
                    }
                });

                if(results.length > 0) {
                    this.itemsToShow = true;
                    let yr = (new Date()).getFullYear();
                    let yearExists = false; 
                    results.forEach(function(result){

                        if(result.year == yr) {
                            yearExists = true;
                        }

                    })

                    if(!yearExists) {

                        let o = vm.createCurrentYear();
                        results.push(o); 
                    }
             

                } else {
                    this.itemsToShow = false; 
                }

                
                
                return this.sortResults(results);
                
            },
            getDiseaseStateClassName: function(targetId) {
                let finalClass = ''; 

                if(targetId == '')
                {
                    return ''; 
                }
               
                let diseaseStates = this.$store.getters.getDiseaseStates; 
                let filtered = diseaseStates.filter( el => {
                    return el.tid[0].value == targetId;
                });

                // Abort if no diseaseState with targetId is found 
                if (!filtered[0]) {
                    return finalClass;
                }

                if(filtered[0].parent[0].target_id === null) {
                    finalClass += filtered[0].name[0].value;  
                } else {
                    let extraFilter = diseaseStates.filter( el => el.tid[0].value == filtered[0].parent[0].target_id); 
                    finalClass += extraFilter[0].name[0].value; 
                }
                
                return finalClass; 
            },
            getTrackingLabelData: function(item) {
                const phase = this.getPhaseData(item.field_phase_tag[0].target_id, 'name', 'value');
                const product = this.getTaxonomyData(item.field_product_list[0].target_id, 'title', 'value');
                return `${phase} ${product}`;
            },
            trackEvent: function(event) {
                this.analytics.trackEvent(this.$router.currentRoute.path, 'navigation', event.target);
            },
            onAccepted: function() {
                this.disclaimerParams = null;
            }
        }
    }
</script>

<style>
    .small-grid {
        grid-template-columns: repeat(12, 0.1fr);

    }

    .timeline::-webkit-scrollbar {
        display: block !important;
    }

    .timeline::-webkit-scrollbar {
        display: block !important;
        padding-bottom: 3px;
        padding-top: 3px;
        width: 10px;
    }

    .timeline::-webkit-scrollbar-thumb {
        background: #003B33;
        border-radius: 10px;
    }

    .timeline::-webkit-scrollbar-track {
        background: #d9d9d9;
    }


</style>
